export const ScrollTheMouseWheelIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="59" height="64" viewBox="0 0 59 64" fill="none">
    <mask
      id="mask0_444_208"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="9"
      y="0"
      width="45"
      height="64"
    >
      <path
        d="M53.2277 16.8551L52.8571 25.3775C52.815 26.3464 51.7623 26.9271 50.9203 26.446C50.1262 25.9922 49.1246 26.482 48.9952 27.3875L46.2649 46.5L45.7759 49.1891C45.5014 50.6993 46.5815 52.1197 48.1101 52.2587C49.5676 52.3912 50.6321 53.6948 50.4705 55.1494L50.0094 59.2987C49.8641 60.6072 48.8825 61.6681 47.5891 61.9144L39.6726 63.4223C39.4021 63.4739 39.1257 63.4879 38.8514 63.464L17.6199 61.6178C16.7587 61.5429 15.9717 61.1003 15.4605 60.4032L11.3189 54.7555C10.9581 54.2635 10.7559 53.6733 10.7392 53.0635L9.78789 18.3405C9.77283 17.7908 9.90918 17.2474 10.182 16.7699L18.9011 1.51158C19.4352 0.576858 20.4293 0 21.5058 0H42.5103C43.5941 0 44.5937 0.584588 45.125 1.52922L52.8452 15.254C53.1195 15.7416 53.252 16.2962 53.2277 16.8551Z"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0_444_208)">
      <rect
        x="12.9715"
        y="3.77965"
        width="37.9431"
        height="55.6152"
        rx="16.0153"
        stroke="#B9BCCB"
        strokeWidth="1.5593"
      />
      <line x1="12.7649" y1="26.2203" x2="33.7649" y2="26.2203" stroke="#B9BCCB" strokeWidth="1.5593" />
      <line
        x1="32.0734"
        y1="10.4622"
        x2="32.0734"
        y2="19.5279"
        stroke="#BB96FF"
        strokeWidth="2.83074"
        strokeLinecap="round"
      />
    </g>
    <path
      d="M34.0868 35.9878L33.3439 18.0328C33.3091 17.1924 33.5949 16.3733 34.1385 15.7556C34.682 15.1379 35.4387 14.7722 36.2421 14.7389C37.0456 14.7057 37.8299 15.0076 38.4226 15.5783C39.0153 16.1491 39.3678 16.9418 39.4026 17.7821L40.0581 33.6248"
      stroke="#848199"
      strokeWidth="1.74275"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M45.8018 29.1237C45.8018 28.3196 46.1213 27.5484 46.6899 26.9798C47.2585 26.4112 48.0296 26.0918 48.8338 26.0918C49.6379 26.0918 50.4091 26.4112 50.9777 26.9798C51.5463 27.5484 51.8657 28.3196 51.8657 29.1237V32.1557"
      stroke="#848199"
      strokeWidth="1.74275"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M39.7646 27.5564C39.7646 26.7522 40.084 25.981 40.6526 25.4124C41.2212 24.8438 41.9924 24.5244 42.7965 24.5244C43.6006 24.5244 44.3718 24.8438 44.9404 25.4124C45.509 25.981 45.8285 26.7522 45.8285 27.5564V30.5883"
      stroke="#848199"
      strokeWidth="1.74275"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M51.8657 31.1452C51.8657 30.3411 52.1852 29.5699 52.7538 29.0013C53.3224 28.4327 54.0936 28.1133 54.8977 28.1133C55.7018 28.1133 56.473 28.4327 57.0416 29.0013C57.6102 29.5699 57.9296 30.3411 57.9296 31.1452V40.241C57.9296 43.4575 56.6519 46.5423 54.3775 48.8167C52.1031 51.0911 49.0183 52.3688 45.8019 52.3688H41.7593H42.1797C40.1712 52.3692 38.1941 51.8707 36.4258 50.9181C34.6576 49.9655 33.1536 48.5887 32.049 46.9113L31.6528 46.3049C31.0222 45.3367 28.4948 41.3711 22.6857 34.7264C22.2985 34.0382 22.1951 33.2261 22.3974 32.4628C22.5997 31.6996 23.0918 31.0454 23.7691 30.6393C24.4904 30.2065 25.3357 30.0271 26.1707 30.1297C27.0057 30.2322 27.7824 30.6108 28.3776 31.2053L33.7231 36.1429"
      stroke="#848199"
      strokeWidth="1.74275"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.18543 31.3033L4.49433 34.5786C4.2894 34.828 3.9103 34.8359 3.69515 34.5953L0.869925 31.4349"
      stroke="#FFB4C9"
      strokeWidth="1.73982"
      strokeLinecap="round"
    />
    <path d="M4.04367 24.96L4.06034 32.9475" stroke="#FFB4C9" strokeWidth="1.73982" strokeLinecap="round" />
    <path
      d="M1.14794 11.3149L3.83904 8.03957C4.04398 7.79014 4.42308 7.78224 4.63823 8.02291L7.46345 11.1833"
      stroke="#FFB4C9"
      strokeWidth="1.73982"
      strokeLinecap="round"
    />
    <path d="M4.2897 17.6582L4.27303 9.67062" stroke="#FFB4C9" strokeWidth="1.73982" strokeLinecap="round" />
  </svg>
);
